export const DISTINCT_VALUE_OBSERVABLE_PRIVATE = Symbol('distinct-value-observable-private');
//# sourceMappingURL=privates.js.map